export const ContactGroupTypes = {
  CONTACT: 'CONTACT',
  FAVORITE: 'FAVORITE',
  MARKETING: 'MARKETING',
  APPEND: 'APPEND',
};

export default ContactGroupTypes;
